"use client"

import { ArrowRight, BookOpen, Clock } from "lucide-react"

import { GlassCard } from "@shared/ui/landing/glass-card"
import { SectionContainer } from "@shared/ui/landing/section-container"
import { StatusTag } from "@shared/ui/landing/status-tag"
import { buttonVariants } from "@shared/ui/components/button"
import { cn } from "@shared/ui/lib/utils"

import { knowledgeArticles } from "@/lib/live-data"
import { useTranslations } from "@/lib/i18n/client"

export function KnowledgeBaseSection() {
  const t = useTranslations("knowledge")

  return (
    <SectionContainer id="knowledge" className="py-12 md:py-20">
      <div className="mb-8 flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end md:mb-12">
        <div className="space-y-2">
          <h2 className="text-2xl font-bold tracking-tight md:text-3xl">{t("title")}</h2>
          <p className="max-w-xl text-muted-foreground">{t("subtitle")}</p>
        </div>
        <a
          href="#"
          className={cn(
            buttonVariants({ variant: "outline", size: "sm" }),
            "gap-2 border-white/15 bg-white/5"
          )}
        >
          {t("viewAll")}
          <ArrowRight className="size-4" />
        </a>
      </div>

      <div className="grid gap-4 sm:grid-cols-2">
        {knowledgeArticles.map((article) => (
          <GlassCard
            key={article.id}
            className="cyber-border group transition-colors hover:border-amber-500/30"
          >
            <div className="mb-3 flex items-center justify-between">
              <StatusTag variant="info">{t(article.categoryKey)}</StatusTag>
              <span className="flex items-center gap-1 text-xs text-muted-foreground">
                <Clock className="size-3" />
                {t("readTime", { minutes: article.readMinutes })}
              </span>
            </div>
            <h3 className="font-semibold group-hover:text-amber-400">{t(article.titleKey)}</h3>
            <p className="mt-2 line-clamp-2 text-sm text-muted-foreground">
              {t(article.excerptKey)}
            </p>
            <a
              href="#"
              className="mt-4 inline-flex items-center gap-1.5 text-sm text-amber-400 hover:underline"
            >
              <BookOpen className="size-3.5" />
              {t("readMore")}
            </a>
          </GlassCard>
        ))}
      </div>
    </SectionContainer>
  )
}
